var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"dense":"","value":_vm.lang,"items":_vm.languages,"label":_vm.$t('config.language')},on:{"change":_vm.onSelectLang}})
}
var staticRenderFns = []

export { render, staticRenderFns }